module.exports = __webpack_public_path__ + "40eff96230690f40f07fb8abf65d545e.svg";